import React, { useEffect, useState } from "react";
import axios from "axios";
import Framework from "../components/Pages/Frameworks";
import Demand from "../components/Pages/demandPage";
import CreateBot from "../components/Pages/createBotFormss";
import BotDetails from "../components/Pages/botDetailPage";
import BotStore from "../components/Pages/botStorePage";
import Productdetails from "../components/Pages/Product/ProductDetailsPage"
import Productdetailscupa from "../components/Pages/Product/Productdetailscupa"
import Productdetailssap from "../components/Pages/Product/Productdetailssap"
import Productdetailschatbot from "../components/Pages/Product/Productdetailschatbot"
import Productsdetailssuit from "../components/Pages/Product/Productsdetailssuit"
import ContactUs from "../components/Pages/contactUsPage";
import Header from "../components/header";
import Footer from "../components/footer/index";
import CEZ from "../components/Pages/cezs";
import Profile from "../components/Pages/ProfilePage";
import EditBot from "../components/Pages/EditBotPage";
import { useRouter } from "next/router";
import Logout from "../components/Pages/Logout";
import UserAccessMapping from "../components/Pages/userAccessMapping";
import Approval from "../components/Pages/approvals";
import GlobalSearch from "../components/Pages/globalSearch";
import ApprovalForm from "../components/Pages/approvalForm";
import Loader from "../components/Loader";
import Modal from "../pages/successModal/index";
import endPoints from "../utility/endpoints";
import Offering from "../components/offerings/offerings.jsx";
import IA_Offering from "../components/Pages/iaProductDevelopment&Deployment";

import { connect } from "react-redux";
import { sessionTimeOutCheck, checkExpiry } from "../redux/global/actions";
import { bindActionCreators } from "redux";
import Product from "../components/Pages/Product";
import Productdetailsshareonshelf from "../components/Pages/Product/Productdetailsshareonshelf"
import Productdetailsneo from "../components/Pages/Product/Productdetailsneo"

import Order from "../components/Pages/Order";
import CreateEmployeeTwin from "../components/CreateEmployeeTwin";
import EditEmployeeTwin from "../components/EditEmployeeTwin";
import Employeetwin from "../components/Employeetwin";
import Emptwincart from "../components/emptwincart";
import Employeetwinskills from "../components/Employeetwinskills";
import Employeetwinsdetails from "../components/Employeetwinsdetails";
import SoftSkillsDetails from "../components/SoftSkillsDetails";
import Emptwinorderlisting from "../components/emptwinorderlisting";
import PurchaseET from "../components/PurchaseET";
import ManageEmployeetwin from "../components/ManageEmployeetwin";
import ROI from "../components/roi";
import NewEmployeetwin from "../components/newEmployeetwin";

import ETProfile from "../components/layout/checkout/ETProfile";
import CCDetails from "../components/layout/checkout/CCDetails";
import ETComments from "../components/layout/checkout/ETComments";
import ThankyouPage from "../components/layout/checkout/Thankyoupage";
import ETskills from "../components/layout/checkout/ETskills";
import ProgressBarData from "../components/layout/checkout/ProgressBarData.jsx"
function Dynamic(props) {
  //console.log("props===", props);
  const router = useRouter();
  //console.log("props", props);

  // console.log("a", props.createBotData.data);
  const [userRole, setUserRole] = useState("admin");
  const [doNotRenderYet, SetDoNotRenderYet] = useState(true);
  const [successModal, setSuccessModal] = useState(false);
  const [fallBackPage, setFallBackPage] = useState(false);
  const scrollToTopRef = React.useRef(null);

  const [Loading, setLoading] = useState(false);
 const Etroles=[
    "sanjay.bohra@unilever.com",
    "Shravyashree.JC@unilever.com",
    "Sachin.Jalota@unilever.com",
    "Arnik.Khillar@unilever.com",
    "dinesh.s3@unilever.com",
    "Prashant.Singh2@unilever.com",
    "Ritish.Verma@unilever.com",
    "swedha.balasubramanian@unilever.com",
    "Rahul.yadav2@unilever.com",
    "aswinkanth.haridas@unilever.com",
    "Abhishek.U@unilever.com",
    "Anshu.rani@unilever.com",
    "mani.jha@unilever.com",
    "madhurima.jaggi@unilever.com",
    "binay.kumar@unilever.com",
    "Vinoth.Bhaskar@unilever.com",
    "Vivek.Sharma@unilever.com",
    "Anubha.Aggarwal@unilever.com",
    "Komal.Falodiya@unilever.com",
    "Gopikrishna.M@unilever.com",
    "Soumya.Mohanty@unilever.com",
    "Ashish.Dhagat@unilever.com",
    "Mayuri.Bhavnani@unilever.com",
    "Vidish.Verma@unilever.com",
    "Ayush.Rautela@unilever.com",
    "Subhadip.Das@unilever.com",
    "Arti.Hajnale@unilever.com"
]

  

 

  useEffect(() => {
    try {
      if (props.path != "login") {
        if (localStorage.getItem("auth") != undefined) {
          const token = JSON.parse(localStorage.getItem("auth"));
          //  console.log(token, "auth path js");
          // console.log("token userType  ", token.data.userType);
          setUserRole(token.data.userType);
          SetDoNotRenderYet(false);
        }
      } else {
        SetDoNotRenderYet(false);
      }
    } catch (err) {
      //console.log(err);
    }
  }, []);

  const {
    data: { code, data },
  } = props;
    const pageRoutes = props?.data?.data?.site_info?.menu_component?.menu_list;
  const footerProps = props?.data?.data?.site_info?.footer_component[0];
  const headerProps = props.data?.data?.site_info;

  //console.log(props, "props at path");

  const { title } = data;

//console.log("line sakib==>>",title)

  let ComponentToRender;

  switch (title) {
    case "Framework":
      ComponentToRender = (
        <Framework
          data={props.data.data.field_basic_component}
          userRole={userRole}
        />
      );
      break;

 case "Employeetwin":
          ComponentToRender = (
            <Employeetwin data={props.data.data.field_landing_page_component} globalData={props.data.data.site_info} pageRoutes={pageRoutes} softskill={props.cartData} Etroles={Etroles}/>
          );
        break;
      	case "Employeetwinskills":
          ComponentToRender = (
            <Employeetwinskills data={props.data.data.field_component} globalData={props.data.data.site_info} pageRoutes={pageRoutes} softskill={props.cartData} softskill1={props.softSkillData} Etroles={Etroles}/>
          );
        break;
        case "Employeetwinsdetails":
          ComponentToRender = (
            <Employeetwinsdetails data={props.data.data.field_component} globalData={props.data.data.site_info} pageRoutes={pageRoutes} softskill={props.cartData} softskill1={props.softSkillData} Etroles={Etroles}/>
          );
        break;
           case "ManageEmployeetwin":
          ComponentToRender = (
            <ManageEmployeetwin data={props.data.data.field_component} globalData={props.data.data.site_info} pageRoutes={pageRoutes} softskill={props.cartData} softskill1={props.softSkillData} Etroles={Etroles}/>
          );
        break;
	case "Return On Investment":
          ComponentToRender = (
           <ROI data={props.data.data.field_component} globalData={props.data.data.site_info} technology={props.requestDemoData.data} pageRoutes={pageRoutes} Etroles={Etroles} />
         );
        break;
        case "CreateEmployeeTwin":
      ComponentToRender = (
        <CreateEmployeeTwin  data={props.data.data.field_new_bot_component} globalData={props.data.data.site_info} softskill={props.softSkillData}/>
      );
      break;
      case "EditEmployeeTwin":
        ComponentToRender = (
          <EditEmployeeTwin  data={props.data.data.field_new_bot_component} globalData={props.data.data.site_info} softskill={props.softSkillData}/>
        );
      break;
      case "Emptwincart":
          ComponentToRender = (
            <Emptwincart  globalData={props.data.data.site_info} pageRoutes={pageRoutes}/>
          );
      break;
      case "Order":
        ComponentToRender = (
          <Order data={props.data.data.field_component} userRole={userRole} feedback={props.feedbackData}  pageRoutes={pageRoutes}/>
        );
        break;
        case "softskilldetails":
          ComponentToRender = (
            <SoftSkillsDetails data={props.data.data} globalData={props.data.data.site_info} pageRoutes={pageRoutes}/>
          );
        break;
        case "Orderlisting":
          ComponentToRender = (
            <Emptwinorderlisting  globalData={props.data.data.site_info} pageRoutes={pageRoutes}/>
          );
      break;
 case "Purchaseemployeetwin":
          ComponentToRender = (
            <PurchaseET data={props.data.data.field_component} globalData={props.data.data.site_info} pageRoutes={pageRoutes} softskill={props.cartData} softskill1={props.softSkillData} Etroles={Etroles}/>
          );
        break;
      
       
	case "Product":
          ComponentToRender = (
            <Product data={props.data.data.field_component} userRole={userRole} />
          );
        break;
      case "Offerings":
        if(props.data.data.field_offering_variant == "0"){
        ComponentToRender = (
        <Offering
        data={props.data.data.field_content_component}
        
        />
        );
        }else{
          ComponentToRender = (
            <Offering
            data={props.data.data.field_content_component}
            
            />
            );
        }
        break;

    case "Catalogue Products":
        ComponentToRender=(
          <IA_Offering
          data = {props.data.data.field_offering_content_component}
          title={props.data.data.title}
          />
        );
        break;
    case "Touchless Processes":
          ComponentToRender=(
            <IA_Offering
            data = {props.data.data.field_offering_content_component}
            title={props.data.data.title}
            />
          );
          break;

    case "Profile Automation":
            ComponentToRender=(
              <IA_Offering
              data = {props.data.data.field_offering_content_component}
              title={props.data.data.title}
              />
            );
            break;    

    case "Organic Demand":
              ComponentToRender=(
                <IA_Offering
                data = {props.data.data.field_offering_content_component}
                title={props.data.data.title}
                />
              );
              break;

    case "Intelligent Applications":
          ComponentToRender=(
            <IA_Offering
            data = {props.data.data.field_offering_content_component}
            title={props.data.data.title}
            />
          );
          break;
        
    case "Demand":
      if (
        userRole == "admin" ||
        userRole == "internalUser" ||
        userRole == "supportStatus" 
       
      ) {

      
      ComponentToRender = (
        <Demand
          data={props.data.data.field_basic_content_component}
          userRole={userRole}
        />
      );
      }
      else {
        ComponentToRender = (
          <div style={{ height: "800px" }}>
            <h3>Unauthorised User</h3>
          </div>
        );

      }
      break;

    case "Bot Store":
      ComponentToRender = (
        <BotStore data={props.data.data.field_component} userRole={userRole} />
      );
      break;

    case "Create Bot New":
      if (
        userRole == "admin" ||
        userRole == "internalUser" ||
        userRole == "qrManager" ||
        userRole == "supportStatus"
      ) {
        ComponentToRender = (
          <CreateBot
            data={props.data.data.field_new_bot_component}
            userRole={userRole}
            globalData={props.data.data.site_info}
          />
        );
      } else {
        ComponentToRender = (
          <div style={{ height: "800px" }}>
            <h3>Unauthorised User</h3>
          </div>
        );
      }
      break;

    case "BotEdit":
      ComponentToRender = <EditBot userRole={userRole} />;
      break;

    case "Bot Details":
      ComponentToRender = (
        <BotDetails
          userRole={userRole}
          globalData={props.data.data.site_info}
          data={props.data.data}
        />
      );
      break;
 case "Product Details":
        ComponentToRender = (
          <Productdetails
            checkExpiry={checkExpiry}
            userRole={userRole}
            // globalData={props.data.data.site_info}
            data={props.data.data}
          />
        );
      break;
     
      case "Product Details Cuba":
        ComponentToRender = (
          <Productdetailscupa
            userRole={userRole}
            // globalData={props.data.data.site_info}
            data={props.data.data}
          />
        );
      break;
      case "Product Details SAP":
        ComponentToRender = (
          <Productdetailssap
            userRole={userRole}
            // globalData={props.data.data.site_info}
            data={props.data.data}
          />
        );
      break;
      case "Product Details Chat Bot":
        ComponentToRender = (
          <Productdetailschatbot
            userRole={userRole}
            // globalData={props.data.data.site_info}
            data={props.data.data}
          />
        );
      break;
      case "Product Details Safety Suite":
        ComponentToRender = (
          <Productsdetailssuit
            userRole={userRole}
            // globalData={props.data.data.site_info}
            data={props.data.data}
          />
        );
      break;
     case "Product Details Share":
        ComponentToRender = (
          <Productdetailsshareonshelf
            userRole={userRole}
            // globalData={props.data.data.site_info}
            data={props.data.data}
          />
        );
      break;
     case "Product Details Neo":
        ComponentToRender = (
          <Productdetailsneo
            userRole={userRole}
            // globalData={props.data.data.site_info}
            data={props.data.data}
          />
        );
      break;
    case "Contact Us":
      ComponentToRender = (
        <ContactUs
          data={props.data.data.field_contact_component}
          userRole={userRole}
        />
      );
      break;
    case "Cognitive Experience Zone":
      ComponentToRender = (
        <CEZ
          userRole={userRole}
          data={props.data.data.field_cez_content_component}
        />
      );
      break;
    case "Profile Page":
      ComponentToRender = (
        <Profile
          data={props.data.data.field_component}
          userRole={userRole}
          globalData={props.data.data.site_info}
        />
      );
      break;

    case "Logout Page":
      ComponentToRender = (
        <Logout
          userRole={userRole}
          data={props.data.data.field_component}
          pageRoutes={pageRoutes}
        />
      );
      break;

    case "User Access Mapping":
      ComponentToRender = (
        <UserAccessMapping
          userRole={userRole}
          data={props.data.data}
          globalData={props.data.data.site_info}
        />
      );
      break;

    case "Approvals":
      ComponentToRender = (
        <Approval
          userRole={userRole}
          data={props.data.data.field_basic_content_component}
          globalData={props.data.data.site_info}
        />
      );
      break;
    case "Global Search":
      ComponentToRender = <GlobalSearch />;
      break;

    case "Approval Form":
      ComponentToRender = (
        <ApprovalForm data={props.data.data.field_component} />
      );
      break;
    case "New Employeetwin":
        ComponentToRender = (
          <NewEmployeetwin  globalData={props.data.data.site_info}  />
        );
    break;
       case "CartCheckout":
      ComponentToRender = (
        <ProgressBarData globalData={props.data.data.site_info} pageRoutes={pageRoutes} />
      );
      break;

    case "ETprofile":
      ComponentToRender = (
        <ETProfile globalData={props.data.data.site_info} pageRoutes={pageRoutes} />
      );
      break;

    case "CCDetails":
      ComponentToRender = (
        <CCDetails globalData={props.data.data.site_info} pageRoutes={pageRoutes} />
      );
      break;

    case "ETComments":
      ComponentToRender = (
        <ETComments globalData={props.data.data.site_info} pageRoutes={pageRoutes} />
      );
      break;

    case "ETthankyou":
      ComponentToRender = (
        <ThankyouPage globalData={props.data.data.site_info} pageRoutes={pageRoutes} />
      );
      break;
    default:
      // setFallBackPage(true);
      ComponentToRender=(
      <h1>hii</h1>
      );
      break;
  }
  return !doNotRenderYet ? (
    <div>
      {title == "Login Page" || title == "Logout Page" ? null : (
        <>
          <div id="headTop" ref={scrollToTopRef}></div>
          <Header
            title={title}
            pageRoutes={pageRoutes}
            userRole={userRole}
            requestDemoData={props.requestDemoData}
            headerProps={headerProps}
          />
        </>
      )}
      {
        props.routeChangeState ?<div style = {{height : "800px"}}> <Loader/> </div> : ComponentToRender
      }

      {props.session ? (
        <Modal
          message={"Session Expired"}
          title={"Login Session Status"}
          session={props.session}
          sessionTimeOutCheck={props.sessionTimeOutCheck}
          setSuccessModal={setSuccessModal}
          fail={true}
        />
      ) : null}

      <Footer footerProps={footerProps} title={title} />
    </div>
  ) : fallBackPage ? (
    <h1>There's some problem. Please go to home</h1>
  ) : null;
}

export const getServerSideProps = async (context) => {
  const {
    params: { path },
  } = context;
 
  //console.log(path, "Chahiye tera path, tera path chahiye")
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

  var urlencoded = new URLSearchParams();
  urlencoded.append("alias", `/${path}`);

  const resp = await axios({
    method: "post",
    url: `${endPoints.drupalIpContent}/content/get.json`,
    data: urlencoded,
    headers: myHeaders,
  });

  let myHeaderRequestDemo = new Headers();
  myHeaderRequestDemo.append(
    "Content-Type",
    "application/x-www-form-urlencoded"
  );
  let urlencodedRequestDemo = new URLSearchParams();
  urlencodedRequestDemo.append("alias", "/requestDemo");

  const respRequestDemo = await axios.post(
    `${endPoints.drupalIpContent}/content/get.json`,
    urlencodedRequestDemo,
    { headers: myHeaderRequestDemo }
  );

  /*soft Skill popup*/

  let softSkill = new Headers();
  softSkill.append(
    "Content-Type",
    "application/x-www-form-urlencoded"
  );
  let urlencodedsoftSkill = new URLSearchParams();
  urlencodedsoftSkill.append("alias", "/softSkill");

  const respsoftSkill = await axios.post(
    `${endPoints.drupalIpContent}/content/get.json`,
    urlencodedsoftSkill,
    { headers: softSkill }
  );

  /*end soft Skill popup*/

   /*cart popup*/

   let cart = new Headers();
   cart.append(
     "Content-Type",
     "application/x-www-form-urlencoded"
   );
   let urlencodedcart = new URLSearchParams();
   urlencodedcart.append("alias", "/cart");
 
   const respcart = await axios.post(
     `${endPoints.drupalIpContent}/content/get.json`,
     urlencodedcart,
     { headers: cart }
   );
 
   /*end cart popup*/

      /*feedback popup*/

      let feedback = new Headers();
      feedback.append(
        "Content-Type",
        "application/x-www-form-urlencoded"
      );
      let urlencodedfeedback = new URLSearchParams();
      urlencodedfeedback.append("alias", "/feedback");
    
      const respfeedback = await axios.post(
        `${endPoints.drupalIpContent}/content/get.json`,
        urlencodedfeedback,
        { headers: feedback }
      );
    
      /*end feedback popup*/

  return {
    props: {
      data: resp.data,
      path: context.query.path,
      requestDemoData: respRequestDemo.data,
      softSkillData:respsoftSkill.data,
      cartData:respcart.data,
      feedbackData:respfeedback.data
    },
  };
};

const mapStateToProps = (state) => {
  //console.log("state",state)
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Dynamic);
